import { format } from 'date-fns';

import { OjEvent } from '../../../shared/api';
import { DATE_SEARCH_PARAM_FORMAT } from '../../../shared/model/search';

export function getFeedSearch(event?: OjEvent) {
  return event
    ? {
        date: format(event.start_at, DATE_SEARCH_PARAM_FORMAT),
      }
    : undefined;
}
